import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import { eventRegistrationUrl } from '@buyside/util/urlHelper';

import styles from './toasterStyles.scss';

const EventToaster: React.FC = () => {
  return (
    <>
      <div>
        <span>
          AlphaSense &times; SumZero Buyside Idea Dinner &mdash; NYC.{' '}
          <strong>June 10, 2026.</strong>
        </span>
        <div className={styles.actions}>
          <Link to={eventRegistrationUrl()}>Register Today!</Link>
        </div>
      </div>
    </>
  );
};

export default EventToaster;
